import React from 'react';
import Select, { Props as SelectProps } from 'react-select';
import classNames from 'classnames';

const Dropdown: React.FC<any> = ({
    options,
    value,
    onChange,
    id,
    roundedRectangle = false,
    small = false,
    defaultMenuIsOpen = false,
    isMulti = false,
    readOnly = false,
    dropdownProps = {},
    hasError = false,
}) => {
    return (
        <Select
            className={classNames(
                'CustomSelect',
                { RoundedRect: roundedRectangle },
                { Small: small },
                { ErrorInput: hasError }
            )}
            inputId={id}
            defaultMenuIsOpen={defaultMenuIsOpen}
            classNamePrefix='CustomSelect'
            options={options}
            value={value}
            isDisabled={readOnly}
            onChange={onChange}
            isMulti={isMulti}
            menuPlacement="auto"
            {...dropdownProps}
        />
    );
};

export default Dropdown;
